import React from 'react';
import PropTypes from 'prop-types';

export default function PrintCountDisplay({
  selectedCount,
  totalCount,
  text,
  classNames,
  hideTotal,
}) {
  return (
    <span data-test-id="print-count-display" className={classNames}>
      {selectedCount}
      <span className={(hideTotal && 'd-none') || ''}>{`/${totalCount}`}</span>
      {text && ` ${text}`}
    </span>
  );
}

PrintCountDisplay.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  text: PropTypes.string,
  hideTotal: PropTypes.bool,
  classNames: PropTypes.string,
};

PrintCountDisplay.defaultProps = {
  text: '',
  classNames: '',
  hideTotal: false,
};
